import React, { Fragment } from 'react';
import Radio from '@mos-cat/radio';
import Checkbox from '@mos-cat/checkbox';
import { Heading } from '@mos-cat/typography';
import { Dispatch } from 'redux';
import { connect } from 'dva';
import { t, Trans } from '@lingui/macro';
import cn from 'classnames';
import { SPOUSE_FIELD_NAME } from '../../../constants/fieldNames';
import { ADDRESS_MATCH } from '../../../constants/spouse';
import { getPayload } from '../../../helpers/handlers';
import { getValue } from '../../../constants/getFieldValues';
import AddressDirectory from '../../shared/Address/AddressDirectory/AddressDirectory';
import { SPOUSE } from '../../../constants/modelNames';
import { i18n } from '../../../helpers/i18n';
import { showAddressHints } from '../../../selectors/child';

function SpouseAddress({
  spouse,
  addressHints,
  onChange,
  ...props
}): JSX.Element {
  const { addressMatchWithApplicant, isRegisteredInMoscow } = spouse;
  const value = getValue(addressMatchWithApplicant);
  const error = addressMatchWithApplicant.error;
  const addressMatch = value === ADDRESS_MATCH.match;
  const addressNotMatch = value === ADDRESS_MATCH.notMatch;
  const classes = cn('StepContentBlock', {
    StepContentBlock_noMarginBottom: addressNotMatch,
  });

  return (
    <Fragment>
      <div className={classes}>
        <Heading level={3} className="PguFormGrid__row SpouseAddress__Title">
          <Trans>Адрес регистрации по месту жительства (по паспорту)</Trans>
        </Heading>
        <div className="PguFormGrid__row">
          <Radio
            className="PguFormGrid_col"
            label={i18n._(t`Совпадает с адресом заявителя`)}
            name={SPOUSE_FIELD_NAME.addressMatchWithApplicant}
            value={ADDRESS_MATCH.match}
            error={error}
            checked={addressMatch}
            onChange={onChange}
          />
        </div>
        <div className="PguFormGrid__row ChildAddress_address-hint">
          <p className="PguFormGrid_col ChildAddress_address-text ym-hide-content">
            {addressHints.applicantAddress}
          </p>
        </div>
        <div className="PguFormGrid__row">
          <Radio
            label={i18n._(t`Не совпадает с адресом заявителя`)}
            name={SPOUSE_FIELD_NAME.addressMatchWithApplicant}
            value={ADDRESS_MATCH.notMatch}
            error={error}
            checked={addressNotMatch}
            onChange={onChange}
          />
        </div>
        {addressNotMatch && (
          <Checkbox
            className="RegisteredInMoscowCheckbox"
            checked={isRegisteredInMoscow}
            value="isRegisteredInMoscow"
            onChange={props.toggleRegisteredInMoscow}
            label={i18n._(t`Местом жительства (по паспорту) является Москва`)}
          />
        )}
      </div>
      {addressNotMatch && isRegisteredInMoscow && (
        <div className="Form__Row">
          <AddressDirectory model={SPOUSE} />
          <div className="Form__Aside Form__Aside_address">
            <div className="Content__sub">
              <p className="Content__subText">
                <Trans>
                  Для ввода адреса в Зеленограде, в случае отсутствия улицы и
                  дома, укажите адрес в формате: «Зеленоград, корпус N»
                </Trans>
              </p>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange(event) {
    const payload = getPayload(event);
    dispatch({
      type: 'spouse/address/change/matchWithApplicant',
      payload,
    });
  },
  toggleRegisteredInMoscow({ target: { checked } }) {
    dispatch({
      type: 'spouse/address/toggle/isRegisteredInMoscow',
      payload: checked,
    });
  },
});

export default connect(
  (state) => ({ spouse: state.spouse, addressHints: showAddressHints(state) }),
  mapDispatchToProps
)(SpouseAddress);
